import { Repuesto } from '@/domain/entities/repuesto';
import { IRepuestoRepository } from '@/domain/repositories/IRepuestoRepository';

export class GetRepuestosUseCase {
  constructor(private readonly repository: IRepuestoRepository) {}

  async execute(): Promise<Repuesto[]> {
    return this.repository.findAll();
  }
}
